import React from 'react'

import {
  Container,
  Segment,
  Header,
  Form,
  Checkbox,
  Button,
} from 'semantic-ui-react'
import Datetime from 'react-datetime'
import gql from 'graphql-tag'
import { ApolloConsumer } from 'react-apollo'

const DatePicker = props => (
  <div style={{ height: 40 }}>
    <Datetime
      value={props.value}
      onChange={props.onChange}
      dateFormat="MM/DD/YYYY"
      timeFormat={false}
    />
  </div>
)

const daysAgoInMilliseconds = days => {
  return Date.now() - days * 24 * 60 * 60 * 1000
}

const TwoWeeksAgo = daysAgoInMilliseconds(14)

const SCS_ELIGIBLE_QUERY = gql`
	query scsEligible($startTime: Float = ${TwoWeeksAgo}, $endTime: Float) {
		candidates(startTime: $startTime, endTime: $endTime, status: "eligible") {
			count
		}
	}
`

const SCS_OPTINS_QUERY = gql`
	query scsOptins($startTime: Float = ${TwoWeeksAgo}, $endTime: Float) {
		candidates(startTime: $startTime, endTime: $endTime, status: "qualified") {
			count
		}
	}
`

const ASSESSMENT_QUERY = gql`
	query Assessments($startTime: Float = ${TwoWeeksAgo}, $endTime: Float) {
		assessments(startTime: $startTime, endTime: $endTime) {
			count
		}
	}
`

const USER_ANSWERS_QUERY = gql`
    query UserAnswers($startTime: Float, $endTime: Float) {
        userAnswers(startTime: $startTime, endTime: $endTime) {
           count
      }
    }
`

const TOP_CONDITIONS_QUERY = gql`
    query TopConditions($startTime: Float, $endTime: Float) {
        topConditions(startTime: $startTime, endTime: $endTime) {
        count
      }
    }
`

const downloads = [
  {
    resource: 'assessment',
    label: 'PainQuiz',
    query: ASSESSMENT_QUERY,
  },
  {
    resource: 'scs_eligible',
    label: 'SCS Eligible',
    query: SCS_ELIGIBLE_QUERY,
  },
  {
    resource: 'scs_optins',
    label: 'SCS Optins',
    query: SCS_OPTINS_QUERY,
  },
  {
    resource: 'user_answers',
    label: 'User Answers',
    query: USER_ANSWERS_QUERY,
  },
  {
    resource: 'top_conditions',
    label: 'Top Conditions',
    query: TOP_CONDITIONS_QUERY,
  },
]

class Downloader extends React.Component {
  state = {
    startTime: undefined,
    endTime: undefined,
    allTime: false,
    metrics: null,
  }

  handleToggle = (e, { name, checked }) => {
    this.setState({ [name]: checked })
  }

  handleChangeFrom = mt => {
    this.setState({ startTime: +new Date(mt.format()) })
  }

  handleChangeTo = mt => {
    const nextDate = new Date(mt.format())
    const endTime = +nextDate.setDate(nextDate.getDate() + 1)
    this.setState({ endTime })
  }

  downloadURI(uri, name) {
    var link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    // document.removeChild(link)
  }

  renderDownloadButton = (download, i) => {
    return (
      <ApolloConsumer key={i}>
        {client => {
          return (
            <Button
              primary
              content={download.label}
              onClick={() => {
                client
                  .query({
                    query: download.query,
                    variables: {
                      startTime: this.state.startTime,
                      endTime: this.state.endTime,
                    },
                  })
                  .then(() => {
                    const filename =
                      download.resource === 'assessment'
                        ? `${download.resource}.xlsx`
                        : `${download.resource}.csv`
                    this.downloadURI(
                      `${process.env.REACT_APP_HOST}/${filename}`,
                    )
                  })
              }}
            />
          )
        }}
      </ApolloConsumer>
    )
  }

  render() {
    const { startTime, endTime, allTime } = this.state
    return (
      <Container>
        <Segment padded>
          <Header as="h1">Downloads</Header>
          <Form>
            <Header as="h5">Select Date range:</Header>
            <Form.Group style={{ alignItems: 'center' }}>
              <div style={{ marginRight: 40 }}>
                <Form.Field
                  control={DatePicker}
                  name="startTime"
                  label="Start Time"
                  value={startTime}
                  onChange={this.handleChangeFrom}
                />
              </div>
              <div style={{ marginRight: 40 }}>
                <Form.Field
                  control={DatePicker}
                  name="endTime"
                  label="End Time"
                  value={endTime}
                  onChange={this.handleChangeTo}
                />
              </div>
              <Form.Field
                control={Checkbox}
                toggle
                name="allTime"
                label="All Time"
                checked={allTime}
                onChange={this.handleToggle}
              />
            </Form.Group>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {downloads.map(this.renderDownloadButton)}
            </div>
          </Form>
        </Segment>
      </Container>
    )
  }
}

export default Downloader
